import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useGetVolumeInOptions } from 'constants/businessTool';

import { SelectComponentControl } from 'components/_basic/SelectComponent/SelectComponentControl';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

import { IProductVolumeInProps } from './types';

import styles from './ProductVolumeIn.module.scss';

export const ProductVolumeIn: React.FC<IProductVolumeInProps> = ({ productName, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const VOLUME_IN_OPTIONS = useGetVolumeInOptions();

  return (
    <Box className={styles.selectContainer}>
      <Box className={styles.selectTitle}> {t('volumeIn')}</Box>
      <SelectComponentControl
        control={control}
        id={concatWithDot(productName, PRODUCT_NAMES.VOLUME_UNITS)}
        name={concatWithDot(productName, PRODUCT_NAMES.VOLUME_UNITS)}
        options={VOLUME_IN_OPTIONS}
        disabled={disabled}
      />
    </Box>
  );
};
